import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { GRADES } from "@/lib/constants";
import { errText } from "@/lib/api";

export default function GradePage() {
  const { user, setGrade } = useAuth();
  const navigate = useNavigate();
  const choose = async (g) => {
    try { await setGrade(g); navigate("/"); }
    catch (e) { toast.error(errText(e)); }
  };
  return (
    <div className="min-h-screen bg-[#f6faf8] flex flex-col">
      <div className="px-6 sm:px-12 py-6"><Logo /></div>
      <div className="flex-1 flex items-center px-6 sm:px-12 pb-16">
        <div className="max-w-4xl w-full rise">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2e7d56]">Привет, {user.username}</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0b2e20] mt-3">В каком ты классе?</h1>
          <p className="text-[#4b6b5c] mt-4 max-w-lg">Мы покажем материалы только для твоего класса. Класс можно поменять в любой момент в шапке сайта.</p>
          <div className="mt-10 grid grid-cols-3 sm:grid-cols-6 gap-3">
            {GRADES.map((g, i) => (
              <button key={g} onClick={() => choose(g)} data-testid={`grade-option-${g}`} style={{ animationDelay: `${i * 60}ms` }}
                className={`rise group aspect-square rounded-2xl border-2 transition-[background-color,border-color,transform] duration-200 hover:-translate-y-1 ${user.grade === g ? "bg-[#1f5f42] border-[#1f5f42] text-white" : "bg-white border-[#d1e7dd] text-[#0b2e20] hover:border-[#2e7d56]"}`}>
                <div className="font-display text-4xl sm:text-5xl font-extrabold">{g}</div>
                <div className="text-xs font-semibold opacity-70 mt-1">класс</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
